"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardsOptionsSerializer = void 0;
var standards_options_model_1 = require("../../../models/settings/standards-options.model");
var StandardsOptionsSerializer = /** @class */ (function () {
    function StandardsOptionsSerializer(standardSetSerializer) {
        this.standardSetSerializer = standardSetSerializer;
    }
    StandardsOptionsSerializer.prototype.serialize = function (_a) {
        var _this = this;
        var standardSets = _a.standardSets;
        var serializedStandardSets = standardSets
            ? standardSets.map(function (item) { return _this.standardSetSerializer.serialize(item); })
            : [];
        return new standards_options_model_1.StandardsOptions({
            standardSets: serializedStandardSets,
        });
    };
    return StandardsOptionsSerializer;
}());
exports.StandardsOptionsSerializer = StandardsOptionsSerializer;
